import { url } from "./utils/url.js";

export const utils = {
  url: url,
};
